import { SnackbarAction } from "notistack";
import { bibliographyService } from "../../services/bibliographyService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Bibliography } from "../../types/bibliography";
import { useEntityQueryClient } from "./entityQueryClient";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { extractBibliographyEditLink } from "../../components/entitiesReferences/InternalEntityLink";
import useBibliographyLogic from "../logic/bibliographyLogic";

const useBibliographyQuery = () => {
  const navigate = useNavigate();
  const { defaultBibliography, getDisplayName } = useBibliographyLogic();
  return useEntityQueryClient<Bibliography>({
    service: bibliographyService,
    collection: SystemEntityCollections.BIBLIOGRAPHY,
    defaultEntity: defaultBibliography,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Bibliography): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractBibliographyEditLink(data))}
        sx={{ color: "white" }}
      >
        View Bibliography
      </Button>
    ),
  });
};

export default useBibliographyQuery;

